import React, { useState, useEffect } from 'react';
import { apiFetch, API_BASE } from './api';

export default function JevVeicular({ currentTenant }) {
  const [inspections, setInspections] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('ALL');
  const [searchTerm, setSearchTerm] = useState('');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedJev, setSelectedJev] = useState(null);
  const [notificationMsg, setNotificationMsg] = useState('');

  // Form State para Nova Vistoria JEV
  const [formData, setFormData] = useState({
    customer_id: '',
    vehicle_id: '',
    mileage: 0,
    fuel_level: 50,
    technician_name: 'Técnico Responsável',
    notes: '',
    estimated_cost: 0,
    notify_customer: true,
    checklist_safety: {
      freios: 'OK',
      oleo: 'OK',
      bateria: 'OK',
      pneus: 'OK',
      palhetas: 'OK',
      suspensao: 'OK',
      fluido_freio: 'OK'
    },
    checklist_items: {
      documentos: true,
      estepe: true,
      macaco: true,
      chave_reserva: false,
      objetos_pessoais: ''
    },
    damages: [],
    photos: []
  });

  const [newDamage, setNewDamage] = useState({ part: 'Parachoque Dianteiro', severity: 'Risco Leve', notes: '' });
  const [photoUrlInput, setPhotoUrlInput] = useState('');

  const statusLabels = {
    RECEBIDO: { label: 'Recebido', bg: '#3b82f620', color: '#3b82f6', border: '#3b82f640' },
    EM_DIAGNOSTICO: { label: 'Em Diagnóstico', bg: '#f59e0b20', color: '#f59e0b', border: '#f59e0b40' },
    AGUARDANDO_APROVACAO: { label: 'Aguardando Aprovação', bg: '#8b5cf620', color: '#8b5cf6', border: '#8b5cf640' },
    EM_MANUTENCAO: { label: 'Em Manutenção', bg: '#ec489920', color: '#ec4899', border: '#ec489940' },
    PRONTO_PARA_RETIRADA: { label: 'Pronto para Retirada', bg: '#10b98120', color: '#10b981', border: '#10b98140' },
    ENTREGUE: { label: 'Entregue', bg: '#6b728020', color: '#9ca3af', border: '#6b728040' }
  };

  useEffect(() => {
    fetchInitialData();
  }, [currentTenant]);

  const fetchInitialData = async () => {
    setLoading(true);
    try {
      const tenantParam = currentTenant?.id ? `?tenant_id=${currentTenant.id}` : '';
      const [resJev, resVeh, resCust] = await Promise.all([
        apiFetch(`/api/jev${tenantParam}`),
        apiFetch(`/api/vehicles${tenantParam}`),
        apiFetch(`/api/customers${tenantParam}`)
      ]);

      if (resJev.ok) setInspections(await resJev.json());
      if (resVeh.ok) setVehicles(await resVeh.json());
      if (resCust.ok) setCustomers(await resCust.json());
    } catch (err) {
      console.error('Erro ao carregar dados da JEV:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerChange = (e) => {
    const custId = e.target.value;
    setFormData({ ...formData, customer_id: custId, vehicle_id: '' });
  };

  const filteredVehicles = formData.customer_id
    ? vehicles.filter(v => String(v.customer_id) === String(formData.customer_id))
    : vehicles;

  const handleAddDamage = () => {
    if (!newDamage.part) return;
    setFormData({
      ...formData,
      damages: [...formData.damages, { ...newDamage, id: Date.now() }]
    });
    setNewDamage({ part: 'Porta Dianteira Esquerda', severity: 'Amassado', notes: '' });
  };

  const handleRemoveDamage = (id) => {
    setFormData({
      ...formData,
      damages: formData.damages.filter(d => d.id !== id)
    });
  };

  const handleAddPhoto = () => {
    if (!photoUrlInput.trim()) return;
    setFormData({
      ...formData,
      photos: [...formData.photos, photoUrlInput.trim()]
    });
    setPhotoUrlInput('');
  };

  const handleCreateJev = async (e) => {
    e.preventDefault();
    if (!formData.customer_id || !formData.vehicle_id) {
      alert('Por favor, selecione o Cliente e o Veículo.');
      return;
    }

    try {
      const tenantParam = currentTenant?.id ? `?tenant_id=${currentTenant.id}` : '';
      const res = await apiFetch(`/api/jev${tenantParam}`, {
        method: 'POST',
        body: JSON.stringify(formData)
      });

      if (res.ok) {
        const data = await res.json();
        setNotificationMsg(`Vistoria JEV #${data.id} criada com sucesso!`);
        setShowCreateModal(false);
        fetchInitialData();
        setTimeout(() => setNotificationMsg(''), 4000);
      } else {
        const err = await res.json();
        alert(`Erro ao criar JEV: ${err.detail || 'Falha na requisição'}`);
      }
    } catch (err) {
      alert('Erro de conexão ao criar JEV.');
    }
  };

  const handleUpdateStatus = async (inspectionId, newStatus) => {
    try {
      const tenantParam = currentTenant?.id ? `?tenant_id=${currentTenant.id}` : '';
      const res = await apiFetch(`/api/jev/${inspectionId}${tenantParam}`, {
        method: 'PUT',
        body: JSON.stringify({ status: newStatus })
      });

      if (res.ok) {
        setNotificationMsg(`Status atualizado para: ${statusLabels[newStatus]?.label || newStatus}`);
        fetchInitialData();
        if (selectedJev && selectedJev.id === inspectionId) {
          setSelectedJev({ ...selectedJev, status: newStatus });
        }
        setTimeout(() => setNotificationMsg(''), 4000);
      }
    } catch (err) {
      alert('Erro ao atualizar status.');
    }
  };

  const handleSendWhatsApp = async (inspectionId) => {
    try {
      const tenantParam = currentTenant?.id ? `?tenant_id=${currentTenant.id}` : '';
      const res = await apiFetch(`/api/jev/${inspectionId}/send-whatsapp${tenantParam}`, {
        method: 'POST'
      });

      if (res.ok) {
        setNotificationMsg('📱 Relatório JEV enfileirado para envio no WhatsApp do cliente!');
        setTimeout(() => setNotificationMsg(''), 4000);
      } else {
        const err = await res.json();
        alert(`Erro: ${err.detail}`);
      }
    } catch (err) {
      alert('Erro ao enviar mensagem.');
    }
  };

  const handleDeleteJev = async (inspectionId) => {
    if (!window.confirm('Tem certeza que deseja excluir esta vistoria JEV?')) return;
    try {
      const tenantParam = currentTenant?.id ? `?tenant_id=${currentTenant.id}` : '';
      const res = await apiFetch(`/api/jev/${inspectionId}${tenantParam}`, { method: 'DELETE' });
      if (res.ok) {
        setInspections(inspections.filter(i => i.id !== inspectionId));
        if (selectedJev?.id === inspectionId) setSelectedJev(null);
      }
    } catch (err) {
      alert('Erro ao excluir vistoria.');
    }
  };

  // Filtragem da Lista
  const displayedInspections = inspections.filter(item => {
    const matchesStatus = filterStatus === 'ALL' || item.status === filterStatus;
    const searchLower = searchTerm.toLowerCase();
    const matchesSearch =
      (item.vehicle_model || '').toLowerCase().includes(searchLower) ||
      (item.vehicle_plate || '').toLowerCase().includes(searchLower) ||
      (item.customer_name || '').toLowerCase().includes(searchLower) ||
      (item.technician_name || '').toLowerCase().includes(searchLower);
    return matchesStatus && matchesSearch;
  });

  // Métricas Bento
  const totalCount = inspections.length;
  const recebidosCount = inspections.filter(i => i.status === 'RECEBIDO').length;
  const manutencaoCount = inspections.filter(i => i.status === 'EM_MANUTENCAO').length;
  const prontosCount = inspections.filter(i => i.status === 'PRONTO_PARA_RETIRADA').length;

  return (
    <div style={{ padding: '24px', maxWidth: '1400px', margin: '0 auto', color: '#e2e8f0' }}>
      
      {/* Cabeçalho */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '28px' }}>🚗</span>
            <h1 style={{ margin: 0, fontSize: '24px', fontWeight: '700', background: 'linear-gradient(135deg, #60a5fa, #a78bfa)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              JEV Veicular — Jornada Eletrônica Veicular
            </h1>
          </div>
          <p style={{ margin: '4px 0 0 0', color: '#94a3b8', fontSize: '14px' }}>
            Vistoria digital, checklist de entrada e acompanhamento transparente no WhatsApp do cliente
          </p>
        </div>

        <button
          onClick={() => setShowCreateModal(true)}
          style={{
            background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
            color: '#fff',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '12px',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 4px 14px rgba(37, 99, 235, 0.4)',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          <span>✨</span> Nova Vistoria JEV
        </button>
      </div>

      {/* Alerta de Notificação */}
      {notificationMsg && (
        <div style={{ background: '#10b98120', border: '1px solid #10b981', color: '#34d399', padding: '12px 16px', borderRadius: '10px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>✅</span> {notificationMsg}
        </div>
      )}

      {/* Bento Grid de Estatísticas */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px', marginBottom: '24px' }}>
        <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '16px', padding: '20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{ background: '#3b82f620', width: '48px', height: '48px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>📋</div>
          <div>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#f8fafc' }}>{totalCount}</div>
            <div style={{ fontSize: '13px', color: '#94a3b8' }}>Total de Vistorias</div>
          </div>
        </div>

        <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '16px', padding: '20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{ background: '#f59e0b20', width: '48px', height: '48px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>🔑</div>
          <div>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#fbbf24' }}>{recebidosCount}</div>
            <div style={{ fontSize: '13px', color: '#94a3b8' }}>Veículos Recebidos</div>
          </div>
        </div>

        <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '16px', padding: '20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{ background: '#ec489920', width: '48px', height: '48px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>🛠️</div>
          <div>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#f472b6' }}>{manutencaoCount}</div>
            <div style={{ fontSize: '13px', color: '#94a3b8' }}>Em Manutenção</div>
          </div>
        </div>

        <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '16px', padding: '20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{ background: '#10b98120', width: '48px', height: '48px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>🚀</div>
          <div>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#34d399' }}>{prontosCount}</div>
            <div style={{ fontSize: '13px', color: '#94a3b8' }}>Prontos para Retirada</div>
          </div>
        </div>
      </div>

      {/* Filtros e Busca */}
      <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '16px', padding: '16px', marginBottom: '24px', display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {[
            { key: 'ALL', label: 'Todos' },
            { key: 'RECEBIDO', label: 'Recebido' },
            { key: 'EM_DIAGNOSTICO', label: 'Diagnóstico' },
            { key: 'AGUARDANDO_APROVACAO', label: 'Aguardando Aprovação' },
            { key: 'EM_MANUTENCAO', label: 'Em Manutenção' },
            { key: 'PRONTO_PARA_RETIRADA', label: 'Pronto' },
            { key: 'ENTREGUE', label: 'Entregue' }
          ].map(t => (
            <button
              key={t.key}
              onClick={() => setFilterStatus(t.key)}
              style={{
                background: filterStatus === t.key ? '#3b82f6' : '#0f172a',
                color: filterStatus === t.key ? '#fff' : '#94a3b8',
                border: '1px solid',
                borderColor: filterStatus === t.key ? '#3b82f6' : '#334155',
                padding: '8px 14px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '500',
                transition: 'all 0.15s ease'
              }}
            >
              {t.label}
            </button>
          ))}
        </div>

        <input
          type="text"
          placeholder="Buscar por placa, modelo ou cliente..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{
            background: '#0f172a',
            border: '1px solid #334155',
            color: '#f8fafc',
            padding: '10px 16px',
            borderRadius: '10px',
            fontSize: '14px',
            width: '280px'
          }}
        />
      </div>

      {/* Tabela de Vistorias JEV */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>Carregando vistorias JEV...</div>
      ) : displayedInspections.length === 0 ? (
        <div style={{ background: '#1e293b', borderRadius: '16px', border: '1px solid #334155', padding: '40px', textAlign: 'center', color: '#94a3b8' }}>
          Nenhuma vistoria JEV encontrada. Clique em <strong>"Nova Vistoria JEV"</strong> para cadastrar a entrada de um veículo.
        </div>
      ) : (
        <div style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', display: 'grid', gap: '20px' }}>
          {displayedInspections.map(item => {
            const st = statusLabels[item.status] || { label: item.status, bg: '#334155', color: '#fff', border: '#475569' };
            const shareUrl = `${window.location.protocol}//${window.location.host}/jev/share/${item.public_token}`;

            return (
              <div
                key={item.id}
                style={{
                  background: '#1e293b',
                  border: '1px solid #334155',
                  borderRadius: '16px',
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  justify: 'space-between',
                  transition: 'transform 0.2s ease, border-color 0.2s ease',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                }}
              >
                <div>
                  {/* Status Badge & Id */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                    <span style={{ fontSize: '12px', fontWeight: '700', color: '#64748b' }}>JEV #{item.id}</span>
                    <span style={{
                      background: st.bg,
                      color: st.color,
                      border: `1px solid ${st.border}`,
                      padding: '4px 10px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '600'
                    }}>
                      {st.label}
                    </span>
                  </div>

                  {/* Veículo & Placa */}
                  <h3 style={{ margin: '0 0 4px 0', fontSize: '18px', fontWeight: '700', color: '#f8fafc' }}>
                    {item.vehicle_model || 'Veículo não informado'}
                  </h3>
                  <div style={{ display: 'inline-block', background: '#0f172a', border: '1px solid #334155', color: '#38bdf8', padding: '2px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: '700', letterSpacing: '1px', marginBottom: '12px' }}>
                    {item.vehicle_plate || 'SEM PLACA'}
                  </div>

                  {/* Cliente & Informações Rápidas */}
                  <div style={{ fontSize: '13px', color: '#cbd5e1', marginBottom: '12px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <div>👤 <strong>Cliente:</strong> {item.customer_name || 'N/A'}</div>
                    <div>🛣️ <strong>Quilometragem:</strong> {item.mileage ? `${item.mileage.toLocaleString()} KM` : 'N/I'}</div>
                    <div>⛽ <strong>Combustível:</strong> {item.fuel_level}%</div>
                    <div>👨‍🔧 <strong>Técnico:</strong> {item.technician_name || 'N/I'}</div>
                  </div>

                  {/* Nível de Combustível Bar */}
                  <div style={{ background: '#0f172a', borderRadius: '8px', padding: '4px', marginBottom: '16px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', color: '#94a3b8', marginBottom: '2px' }}>
                      <span>Nível Combustível</span>
                      <span>{item.fuel_level}%</span>
                    </div>
                    <div style={{ background: '#334155', height: '6px', borderRadius: '4px', overflow: 'hidden' }}>
                      <div style={{ background: 'linear-gradient(90deg, #ef4444, #f59e0b, #10b981)', height: '100%', width: `${item.fuel_level}%` }}></div>
                    </div>
                  </div>
                </div>

                {/* Ações */}
                <div style={{ borderTop: '1px solid #334155', paddingTop: '14px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <button
                    onClick={() => setSelectedJev(item)}
                    style={{ flex: 1, background: '#3b82f620', border: '1px solid #3b82f640', color: '#60a5fa', padding: '8px', borderRadius: '8px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}
                  >
                    🔍 Detalhes / Laudo
                  </button>
                  <button
                    onClick={() => handleSendWhatsApp(item.id)}
                    style={{ background: '#10b98120', border: '1px solid #10b98140', color: '#34d399', padding: '8px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}
                    title="Enviar Laudo no WhatsApp"
                  >
                    📱 Zap
                  </button>
                  <button
                    onClick={() => handleDeleteJev(item.id)}
                    style={{ background: '#ef444420', border: '1px solid #ef444440', color: '#f87171', padding: '8px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}
                  >
                    🗑️
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal: Nova Vistoria JEV */}
      {showCreateModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.85)', backdropFilter: 'blur(8px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, padding: '20px' }}>
          <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '20px', width: '100%', maxWidth: '750px', maxHeight: '90vh', overflowY: 'auto', padding: '28px', color: '#f8fafc', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)' }}>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '1px solid #334155', paddingBottom: '16px' }}>
              <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#60a5fa', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>📋</span> Nova Vistoria — Jornada Eletrônica Veicular (JEV)
              </h2>
              <button onClick={() => setShowCreateModal(false)} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '24px', cursor: 'pointer' }}>×</button>
            </div>

            <form onSubmit={handleCreateJev}>
              
              {/* Seção 1: Cliente e Veículo */}
              <div style={{ background: '#0f172a', padding: '16px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #334155' }}>
                <h4 style={{ margin: '0 0 12px 0', color: '#38bdf8', fontSize: '14px' }}>1. Cliente & Veículo</h4>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '12px', color: '#94a3b8', marginBottom: '4px' }}>Cliente *</label>
                    <select
                      value={formData.customer_id}
                      onChange={handleCustomerChange}
                      required
                      style={{ width: '100%', background: '#1e293b', border: '1px solid #334155', color: '#fff', padding: '10px', borderRadius: '8px', fontSize: '13px' }}
                    >
                      <option value="">Selecione o Cliente</option>
                      {customers.map(c => <option key={c.id} value={c.id}>{c.name} ({c.phone || 'S/ Tel'})</option>)}
                    </select>
                  </div>

                  <div>
                    <label style={{ display: 'block', fontSize: '12px', color: '#94a3b8', marginBottom: '4px' }}>Veículo *</label>
                    <select
                      value={formData.vehicle_id}
                      onChange={e => setFormData({ ...formData, vehicle_id: e.target.value })}
                      required
                      style={{ width: '100%', background: '#1e293b', border: '1px solid #334155', color: '#fff', padding: '10px', borderRadius: '8px', fontSize: '13px' }}
                    >
                      <option value="">Selecione o Veículo</option>
                      {filteredVehicles.map(v => <option key={v.id} value={v.id}>{v.model} - {v.plate}</option>)}
                    </select>
                  </div>
                </div>
              </div>

              {/* Seção 2: Medidores e Responsável */}
              <div style={{ background: '#0f172a', padding: '16px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #334155' }}>
                <h4 style={{ margin: '0 0 12px 0', color: '#38bdf8', fontSize: '14px' }}>2. Dados de Entrada</h4>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '12px', color: '#94a3b8', marginBottom: '4px' }}>Quilometragem (KM)</label>
                    <input
                      type="number"
                      value={formData.mileage}
                      onChange={e => setFormData({ ...formData, mileage: parseInt(e.target.value) || 0 })}
                      style={{ width: '100%', background: '#1e293b', border: '1px solid #334155', color: '#fff', padding: '10px', borderRadius: '8px', fontSize: '13px' }}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', fontSize: '12px', color: '#94a3b8', marginBottom: '4px' }}>Combustível ({formData.fuel_level}%)</label>
                    <input
                      type="range"
                      min="0"
                      max="100"
                      value={formData.fuel_level}
                      onChange={e => setFormData({ ...formData, fuel_level: parseInt(e.target.value) })}
                      style={{ width: '100%', marginTop: '10px' }}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', fontSize: '12px', color: '#94a3b8', marginBottom: '4px' }}>Técnico Responsável</label>
                    <input
                      type="text"
                      value={formData.technician_name}
                      onChange={e => setFormData({ ...formData, technician_name: e.target.value })}
                      style={{ width: '100%', background: '#1e293b', border: '1px solid #334155', color: '#fff', padding: '10px', borderRadius: '8px', fontSize: '13px' }}
                    />
                  </div>
                </div>
              </div>

              {/* Seção 3: Checklist Técnico de Segurança */}
              <div style={{ background: '#0f172a', padding: '16px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #334155' }}>
                <h4 style={{ margin: '0 0 12px 0', color: '#38bdf8', fontSize: '14px' }}>3. Checklist de Segurança</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px' }}>
                  {Object.keys(formData.checklist_safety).map(key => (
                    <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#1e293b', padding: '8px 12px', borderRadius: '8px' }}>
                      <span style={{ fontSize: '12px', textTransform: 'capitalize' }}>{key.replace('_', ' ')}</span>
                      <select
                        value={formData.checklist_safety[key]}
                        onChange={e => setFormData({
                          ...formData,
                          checklist_safety: { ...formData.checklist_safety, [key]: e.target.value }
                        })}
                        style={{ background: '#0f172a', border: '1px solid #334155', color: '#fff', padding: '4px 8px', borderRadius: '6px', fontSize: '12px' }}
                      >
                        <option value="OK">🟢 OK</option>
                        <option value="ATENCAO">🟡 Atenção</option>
                        <option value="TROCAR">🔴 Trocar</option>
                      </select>
                    </div>
                  ))}
                </div>
              </div>

              {/* Seção 4: Registro de Avarias Pré-existentes */}
              <div style={{ background: '#0f172a', padding: '16px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #334155' }}>
                <h4 style={{ margin: '0 0 12px 0', color: '#38bdf8', fontSize: '14px' }}>4. Mapeamento de Avarias (Riscados/Amassados)</h4>
                
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr button', gap: '8px', marginBottom: '12px' }}>
                  <input
                    type="text"
                    placeholder="Parte (ex: Parachoque Dianteiro)"
                    value={newDamage.part}
                    onChange={e => setNewDamage({ ...newDamage, part: e.target.value })}
                    style={{ background: '#1e293b', border: '1px solid #334155', color: '#fff', padding: '8px', borderRadius: '6px', fontSize: '12px' }}
                  />
                  <select
                    value={newDamage.severity}
                    onChange={e => setNewDamage({ ...newDamage, severity: e.target.value })}
                    style={{ background: '#1e293b', border: '1px solid #334155', color: '#fff', padding: '8px', borderRadius: '6px', fontSize: '12px' }}
                  >
                    <option value="Risco Leve">Risco Leve</option>
                    <option value="Risco Profundo">Risco Profundo</option>
                    <option value="Amassado">Amassado</option>
                    <option value="Trincado">Trincado</option>
                    <option value="Faltando Peça">Faltando Peça</option>
                  </select>
                  <input
                    type="text"
                    placeholder="Obs (ex: lado direito)"
                    value={newDamage.notes}
                    onChange={e => setNewDamage({ ...newDamage, notes: e.target.value })}
                    style={{ background: '#1e293b', border: '1px solid #334155', color: '#fff', padding: '8px', borderRadius: '6px', fontSize: '12px' }}
                  />
                  <button
                    type="button"
                    onClick={handleAddDamage}
                    style={{ background: '#3b82f6', color: '#fff', border: 'none', padding: '8px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}
                  >
                    + Adicionar
                  </button>
                </div>

                {formData.damages.length > 0 && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {formData.damages.map(d => (
                      <div key={d.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#1e293b', padding: '6px 12px', borderRadius: '6px', fontSize: '12px' }}>
                        <span>⚠️ <strong>{d.part}</strong> — {d.severity} ({d.notes || 'Sem obs'})</span>
                        <button type="button" onClick={() => handleRemoveDamage(d.id)} style={{ background: 'none', border: 'none', color: '#f87171', cursor: 'pointer' }}>✕</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Seção 5: Notificação no WhatsApp */}
              <div style={{ background: '#0f172a', padding: '16px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #334155', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <input
                  type="checkbox"
                  id="notify_whatsapp"
                  checked={formData.notify_customer}
                  onChange={e => setFormData({ ...formData, notify_customer: e.target.checked })}
                  style={{ width: '18px', height: '18px' }}
                />
                <label htmlFor="notify_whatsapp" style={{ fontSize: '13px', color: '#34d399', cursor: 'pointer' }}>
                  📱 Enviar link interativo da JEV via WhatsApp automaticamente para o cliente ao criar
                </label>
              </div>

              {/* Botões do Modal */}
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', borderTop: '1px solid #334155', paddingTop: '16px' }}>
                <button
                  type="button"
                  onClick={() => setShowCreateModal(false)}
                  style={{ background: '#334155', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer' }}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  style={{ background: 'linear-gradient(135deg, #2563eb, #7c3aed)', color: '#fff', border: 'none', padding: '10px 24px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }}
                >
                  Criar Vistoria JEV
                </button>
              </div>

            </form>
          </div>
        </div>
      )}

      {/* Modal: Detalhes do Laudo / Atualizar Status */}
      {selectedJev && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.85)', backdropFilter: 'blur(8px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, padding: '20px' }}>
          <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '20px', width: '100%', maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto', padding: '28px', color: '#f8fafc' }}>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '1px solid #334155', paddingBottom: '16px' }}>
              <div>
                <h2 style={{ margin: 0, fontSize: '20px', color: '#f8fafc' }}>
                  Laudo JEV #{selectedJev.id} — {selectedJev.vehicle_model} ({selectedJev.vehicle_plate})
                </h2>
                <span style={{ fontSize: '13px', color: '#94a3b8' }}>Cliente: {selectedJev.customer_name}</span>
              </div>
              <button onClick={() => setSelectedJev(null)} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '24px', cursor: 'pointer' }}>×</button>
            </div>

            {/* Mudar Status Rápido */}
            <div style={{ background: '#0f172a', padding: '16px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #334155' }}>
              <div style={{ fontSize: '13px', color: '#94a3b8', marginBottom: '8px' }}>Alterar Status do Veículo na Jornada:</div>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {['RECEBIDO', 'EM_DIAGNOSTICO', 'AGUARDANDO_APROVACAO', 'EM_MANUTENCAO', 'PRONTO_PARA_RETIRADA', 'ENTREGUE'].map(code => (
                  <button
                    key={code}
                    onClick={() => handleUpdateStatus(selectedJev.id, code)}
                    style={{
                      background: selectedJev.status === code ? '#3b82f6' : '#1e293b',
                      color: selectedJev.status === code ? '#fff' : '#cbd5e1',
                      border: '1px solid #334155',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      fontSize: '12px',
                      fontWeight: '500',
                      cursor: 'pointer'
                    }}
                  >
                    {statusLabels[code]?.label || code}
                  </button>
                ))}
              </div>
            </div>

            {/* Link de Compartilhamento Direto */}
            <div style={{ background: '#0f172a', padding: '14px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #334155', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
              <div>
                <div style={{ fontSize: '12px', color: '#94a3b8' }}>Link Público do Cliente:</div>
                <div style={{ fontSize: '13px', color: '#38bdf8', wordBreak: 'break-all', fontWeight: '500' }}>
                  {`${window.location.protocol}//${window.location.host}/jev/share/${selectedJev.public_token}`}
                </div>
              </div>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(`${window.location.protocol}//${window.location.host}/jev/share/${selectedJev.public_token}`);
                  alert('Link copiado para a área de transferência!');
                }}
                style={{ background: '#3b82f6', color: '#fff', border: 'none', padding: '8px 14px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer' }}
              >
                📋 Copiar Link
              </button>
            </div>

            {/* Checklist de Segurança */}
            <div style={{ marginBottom: '20px' }}>
              <h4 style={{ color: '#38bdf8', marginBottom: '8px' }}>Checklist de Segurança</h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '10px' }}>
                {Object.entries(selectedJev.checklist_safety || {}).map(([k, v]) => (
                  <div key={k} style={{ background: '#0f172a', padding: '8px 12px', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                    <span style={{ textTransform: 'capitalize' }}>{k.replace('_', ' ')}</span>
                    <strong style={{ color: v === 'OK' ? '#34d399' : v === 'ATENCAO' ? '#fbbf24' : '#f87171' }}>{v}</strong>
                  </div>
                ))}
              </div>
            </div>

            {/* Avarias Registradas */}
            {selectedJev.damages && selectedJev.damages.length > 0 && (
              <div style={{ marginBottom: '20px' }}>
                <h4 style={{ color: '#f472b6', marginBottom: '8px' }}>Avarias Pré-existentes Registradas ({selectedJev.damages.length})</h4>
                <div style={{ background: '#0f172a', padding: '12px', borderRadius: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {selectedJev.damages.map((d, idx) => (
                    <div key={idx} style={{ fontSize: '13px', color: '#cbd5e1' }}>
                      ⚠️ <strong>{d.part}</strong> — <span style={{ color: '#f87171' }}>{d.severity}</span> ({d.notes || 'Sem observações'})
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Botões Finais do Modal */}
            <div style={{ borderTop: '1px solid #334155', paddingTop: '16px', display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
              <button
                onClick={() => handleSendWhatsApp(selectedJev.id)}
                style={{ background: '#10b981', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }}
              >
                📱 Enviar laudo no WhatsApp
              </button>
              <button
                onClick={() => setSelectedJev(null)}
                style={{ background: '#334155', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer' }}
              >
                Fechar
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
}
